module.exports = __webpack_public_path__ + "img/arrow_back.d47e01de.svg";